import React, { useContext, useEffect, useState } from "react";
import { DispatchContext } from "../../../store";
import { useNavigate } from "react-router-dom";
import { conservationApi } from "../../../services/ConservationServices";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import Box from "@mui/material/Box";
import Moment from "react-moment";

const asText = (value) => {
  if (value === null || value === undefined) return "-";
  if (typeof value === "string" || typeof value === "number") return String(value);
  if (typeof value === "object") return value?.name ?? value?.code ?? "-";
  return "-";
};

export default function ConservationTable({ querySearch, museumId }) {
  const dispatch = useContext(DispatchContext);
  const navigate = useNavigate();
  const [conservations, setConservations] = useState([]);
  const [meta, setMeta] = useState({ total: 0 });
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    getConservationList();
  }, [querySearch, page, rowsPerPage, museumId]);

  const getConservationList = () => {
    conservationApi("get", null, {
      search: querySearch,
      state: "approved",
      page: page,
      per_page: rowsPerPage,
      museum_id: museumId,
    }).then((res) => {
      setConservations(res?.data);
      setMeta(res?.meta);
    });
  };

  const handleDetail = (id) => {
    navigate(`/management/conservators/${id}`);
  };

  const handleChangePage = (event, newPage) => {
    dispatch({ type: "IS_NOT_LOADING", payload: false });
    setPage(newPage + 1);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  return (
    <Box sx={{ mt: 2 }}>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="caption table">
          <TableHead>
            <TableRow>
              <TableCell sx={{ color: "#B3B3B3" }}>Sl.No.</TableCell>
              <TableCell align="left" sx={{ color: "#B3B3B3" }}>
                Submission Date
              </TableCell>
              <TableCell align="left" sx={{ color: "#B3B3B3" }}>
                Accession No.
              </TableCell>
              <TableCell align="left" sx={{ color: "#B3B3B3" }}>
                Object Name
              </TableCell>
              <TableCell align="left" sx={{ color: "#B3B3B3" }}>
                Materials
              </TableCell>
              <TableCell align="left" sx={{ color: "#B3B3B3" }}>
                Condition Assisment
              </TableCell>
              <TableCell align="left" sx={{ color: "#B3B3B3" }}>
                Classification
              </TableCell>
              <TableCell colSpan={3} align="right" />
            </TableRow>
          </TableHead>
          <TableBody>
            {conservations?.length > 0 &&
              conservations?.map((conservation, index) => (
                <TableRow key={index} hover onClick={() => handleDetail(conservation?.id)}>
                  <TableCell sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                    {index + 1}
                  </TableCell>
                  <TableCell align="left">
                    <Moment format={"ll"}>{conservation?.created_at}</Moment>
                  </TableCell>
                  <TableCell align="left">{asText(conservation?.accession_no)}</TableCell>
                  <TableCell align="left">{conservation?.catalogue?.object_name || "-"}</TableCell>
                  <TableCell align="left">{asText(conservation?.catalogue?.material)}</TableCell>
                  <TableCell align="left">{conservation?.condition_assessment || "-"}</TableCell>
                  <TableCell align="left">{asText(conservation?.catalogue?.classification)}</TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 100]}
        page={page - 1}
        rowsPerPage={rowsPerPage}
        component="div"
        count={meta?.total}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Box>
  );
}
